import React from 'react';
import Navbar from '../../component/navbar/Navbar';
import HeroSection from '../../component/homeSection/HeroSection';
import SecondSection from '../../component/homeSection/SecondSection';
import ThirdSection from '../../component/homeSection/ThirdSection';
import PromoSection from '../../component/homeSection/PromoSection';
import ShiekSection from '../../component/homeSection/ShiekSection'
import SectionFive from '../../component/homeSection/SectionFive';
import NumSection from '../../component/homeSection/NumSection';
import FAQSection from '../../component/homeSection/FAQSection'
function Home() {
  return (
    <>
      <header>
        <Navbar/>
      </header>
      <main >
        <HeroSection/>
        <SecondSection/>
         <ThirdSection/>
       <PromoSection/>
       <SectionFive/>
       <ShiekSection/>
      <NumSection/>
        <FAQSection/>
      </main>
    </>
  );
}

export default Home;
